<template>
  <IMenu width="176" aria-label="メニュー">
    <template #link>
      <DotsHorizontalSvg width="34" :class="$style.button" />
    </template>
    <template #menu>
      <p v-if="statementForNote" :class="$style.statementForNote"><a :href="statementForNote">特定商法取引情報</a></p>
      <p :class="$style.openingDate">開店日：{{ openingDate }}</p>
    </template>
  </IMenu>
</template>

<script setup lang="ts">
import IMenu from '@/js/components/molecules/IMenu.vue';
import DotsHorizontalSvg from '@/svgs/vue/dots-horizontal.svg';

defineProps<{
  statementForNote: string;
  openingDate: string;
}>();
</script>

<style module lang="scss">
.button {
  border: 1px solid var(--color-gray300);
  border-radius: 50%;
  fill: #4b4b4b;
  position: relative;
  top: 2px;

  &:hover {
    opacity: 0.8;
  }
}

.statementForNote {
  margin-bottom: 10px;

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}

.openingDate {
  color: #b9b9b9;
}
</style>
